<li class="nav-item" [class.active]="isActive(menuItem)" *ngIf="isVisible">
  <a
    *ngIf="menuItem.routerLink"
    class="nav-link"
    [routerLink]="menuItem.routerLink"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}"
    (click)="onItemClick(menuItem)"
    [attr.data-testid]="'side-nav-item-on-item-click-' + testId">
    <ng-container *ngTemplateOutlet="menuItemContent"></ng-container>
  </a>

  <div
    *ngIf="!menuItem.routerLink"
    class="nav-link"
    (click)="onItemClick(menuItem)"
    [attr.data-testid]="'side-nav-item-on-item-click-menu-item-' + testId">
    <ng-container *ngTemplateOutlet="menuItemContent"></ng-container>
  </div>
</li>

<!-- Menu Item Children -->
<ng-container *ngIf="menuItem.children && menuItem.isExpanded && isVisible">
  <ul class="navbar-nav w-100">
    <app-side-nav-item
      *ngFor="let child of menuItem.children; let i = index"
      [menuItem]="child"
      [nestingLevel]="nestingLevel + 1"
      [testIdPath]="testId"
      (changeExpanded)="editExpanded($event)"
      [attr.data-testid]="'side-nav-item-child-' + testId + '-' + i"></app-side-nav-item>
  </ul>
</ng-container>

<!-- Menu Item Template -->
<ng-template #menuItemContent>
  <div class="d-flex w-100">
    <div class="flex-grow-1 nest-level-{{nestingLevel}}">
      <span class="mr-1 fa" [ngClass]="'fa-' + menuItem.icon"></span>
      <span [ngStyle]="applyColor(menuItem)">{{menuItem.primaryText}}</span>
      <span [ngStyle]="applyAltColor(menuItem)">{{menuItem.secondaryText}}</span>
      <span class="float-right" [ngClass]="isErrorNumber ? ' queue-count-error ' : ' queue-count '" *ngIf="menuItem.queue && queueCount > 0">{{queueCount}}</span>
    </div>
    <div *ngIf="menuItem.children" class="text-right">
      <span *ngIf="menuItem.isExpanded; else menuCollapseIcon" class="pull-right fa fa-angle-up"></span>
      <ng-template #menuCollapseIcon>
        <span class="pull-right fa fa-angle-down"></span>
      </ng-template>
    </div>
  </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/core/components/menu/side-nav/side-nav-item/side-nav-item.component.html